
import Vue from 'vue'
import SocketIO from '@/utils/socket'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { logout } from '@/api/sso/user'
import moment from 'moment'
import { QuerySystemParamsPage } from '@/api'
import { clearVueLs } from '@/store/_util/util'

const config = {
  data () {
    return {
      socket: null,
      origin: process.env.VUE_APP_NTY_URL,
      guide: null
    }
  },
  methods: {
    async initWS (val) {
      this.socket && this.socket.close()
      // ** 除了生产环境都不开启推送
      // if (JSON.stringify(val) === '{}' || /^localhost/.test(window.location.host)) return
      if (this.$ls.get(ACCESS_TOKEN)) {
        const url = this.origin + `${process.env.SSO_ENV || ''}`.replace(/(^\S)/, '/$1') + '/sso/ecSocket/' + this.$ls.get(ACCESS_TOKEN)
        this.socket = new SocketIO(url)
        this.socket.on('open', data => {
          // console.log('open:socket', data)
          /* eslint-disable */
          //  setTimeout(() => {
          //   // this.messagePush(JSON.stringify([{ 'createBy': -1, 'createTime': 1634541409936, 'msgInfo': '您当前登录的账号，密码已被CELZX，操作人：18270291002修改，系统将在3S后自动退出，您可以在登录页面找回密码或重新登录。', 'msgInfoEn': '您当前登录的账号，密码已被CELZX，操作人：18270291002修改，系统将在3S后自动退出，您可以在登录页面找回密码或重新登录。', 'msgTitle': '密码修改提醒', 'msgTitleEn': '密码修改提醒', 'msgType': 1, 'platformCode': 'SSO_SYS_USER', 'sendStatus': 2, 'sendTime': 1634541409936, 'subjectId': 24681, 'userId': 18464 }]))
          //   // this.messagePush(JSON.stringify([{ 'createBy': -1, 'createTime': 1642413871863, 'msgInfo': '{"guideScheduleStr":"1011","guideStatus":1,"inventory":7,"listing":8,"order":100,"platformUserName":"amazon_sp_szm_11_CA","status":1,"userAccount":"amazon_sp_szm_11_CA"}', 'msgTitle': '%s已将您的账号删除，请重新登录', 'msgTitleEn': '%s已将您的账号删除，请重新登录', 'msgType': 7, 'platformCode': 'SSO_SYS_USER', 'sendStatus': 2, 'sendTime': 1642413871866, 'subjectId': 233068, 'userId': 235745 }]))
          //   this.messagePush(JSON.stringify([{
          //     createBy: -1,
          //     eject: 0,
          //     id: 63952863,
          //     msgInfo: JSON.stringify({
          //       createBy: 14643,
          //       createTime: 1715595960000,
          //       effective: 1,
          //       liveBeginTime: Date.now() + 15 * 60 * 1000 + 10 * 1000,
          //       liveCoverUrl: 'http://file.eccang.com/ec-saas-file/manager/saas_1715595957381a1f677a925fd5518.png?Expires=4869195957&OSSAccessKeyId=LTAI4FwuSvzhB2y5nmjx4NCY&Signature=8d4xNQrE%2B9DGJaAZwDPO1QdNaAg%3D',
          //       liveDesc: '直播004',
          //       liveEndTime: Date.now() + 15 * 1000,
          //       liveId: 75,
          //       liveIntroduction: '<p>直播004</p>',
          //       liveLink: 'asfdasdfas',
          //       liveName: '直播004',
          //       liveSort: 100,
          //       liveTypeId: 19,
          //       optUserId: 14643,
          //       playbackVideoLink: '',
          //       status: 2,
          //       updateTime: 1716260146000
          //     }),
          //     msgTitle: '直播004直播提醒',
          //     msgTitleEn: '直播004 live alert',
          //     msgType: 3,
          //     platformCode: 'SSO_SYS_USER',
          //     sendStatus: 2,
          //     sendTime: 1716260160107,
          //     subjectId: 2276,
          //     userId: 5234
          //   }]))
          // }, 5000)
        })
        this.socket.on('message', event => {
          this.messagePush(event.data)
        })
        this.socket.on('close', () => {
          setTimeout(() => {
            this.initWS(val)
          }, 5000)
        })
      }
    },
    isUrl (url) {
      return /^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]$/.test(url)
    },
    handleMode (record) {
      if (record.fileUrl && this.isUrl(record.fileUrl)) {
        const url = window.location.protocol.split(':')[0] === 'http' ? 'http' : 'https'
        window.location = `${url}://${record.fileUrl.replace(/^(https?|ftp|file):\/\//i, '')}`
      }
    },
    messagePush (data) {
      if (data === 'ping') return
      console.log('messagePush', data)
      try {
        let _data = JSON.parse(data)
        let message = _data[0]
        if (message.msgTitle === '消息免打扰时间修改通知') {
          this.$store.dispatch('queryClassification')
        }

        // 直播提醒
        if (message.msgType === 3) {
          const msgInfo = /^\{/.test(message.msgInfo) ? JSON.parse(message.msgInfo || '{}') : message.msgInfo
          console.log('msgInfo', msgInfo)
          this.$store.commit('SET_MESSAGE', msgInfo)
          this.$store.dispatch('countdown', this)
          if (message.eject === 1) {
            this.$store.dispatch('notification', this)
          }
          return
        }

        // 引导 TODO
        if (message.msgType === 7) {
          this.guide = message.msgInfo
          return
        }
        // 免打扰 TODO
        const curMessage = this.messageClassification.find(f => f.messageType === message.msgType)
        if (curMessage?.beginTime) {
          const now = moment().format('HH:mm:ss')
          if (!curMessage.isNextDay && now > curMessage.beginTime && now < curMessage.endTime) {
            return
          }
          if (curMessage.isNextDay && now < curMessage.beginTime && now > curMessage.endTime) {
            return
          }
        }
        if (['密码修改通知', '密码修改提醒', '账号停用通知', '删除子账号提醒'].includes(message.msgTitle) && !this.messageFlag) {
          this.count = 3
          let str = message.msgInfo.match(/(3S)(?!.*\1)/)
          if (str?.length) {
            this.timer = setInterval(() => {
              if (this.count <= 0) {
                clearInterval(this.timer)
                this.$store.dispatch('Logout')
                return
              }
              this.count--
            }, 1000)
          }
          const content = h => (
            <div>
              { str ? this.$t(message.msgInfo.substring(0, str.index) + this.count + message.msgInfo.substring(str.index + 1)) : message.msgInfo }
            </div>
          )
          this.$info({
            icon: () => (<icon-font type="gb-icon-Info"></icon-font>),
            title: message.msgTitle,
            content,
            okText: this.$t('layouts.logout'),
            onOk: () => {
              this.$store.dispatch('Logout')
            }
          })
        } else if (['下线通知'].includes(message.msgTitle)) {
          this.$confirm({
            icon: () => (
              <div style="display: flex;align-items: center;">
                <icon-font type="gb-icon-Info" style="font-size:22px;"></icon-font>
                <span style="margin-left: 16px;font-size: 18px;font-weight: 500;color: rgba(0,0,0,0.85);line-height: 1.4;">{ message.msgTitle }</span>
              </div>),
            closable: true,
            content: () => (
              <div style="margin-left:38px;font-size: 16px;font-weight: 500;color: rgba(0,0,0,0.65)">{message.msgInfo}</div>
            ),
            cancelText: this.$t('authority_account_edit_password'),
            okText: this.$t('common_globalcomp_login_again'),
            onCancel: () => {
              const backEmail = 'backEmail'
              return new Promise((resolve) => {
                logout()
                  .finally(() => {
                    clearVueLs(Vue)
                    localStorage.removeItem('X-Auth-Token') // 清空amazon运营登陆状态
                    window.location.href = `/login?backEmail=${backEmail}`
                    resolve()
                  })
              })
            },
            onOk: () => {
              this.$store.dispatch('Logout')
            }
          })
        } else if (this.messageFlag) {
          this.microAppStateActions.setGlobalState({
            messageFlag: false
          })
          return
        } else if (message.msgType === 8) {
          const msgInfo = /^\{/.test(message.msgInfo) ? JSON.parse(message.msgInfo || '{}') : message.msgInfo
          setTimeout(() => {
            const key = `close${new Date()}`
            const content = (
              <div style="font-size: 12px;color: rgba(0,0,0,0.65);margin-top:12px;margin-left: -6px">
                <div style="line-height:22px">
                  {this.$t('down_search_export_content_success_1')}
                  “<span style="color: #077BFC;cursor:pointer;text-decoration: underline;" onClick={() => this.handleMode(msgInfo)}>{this.$t('down_search_export_content_success_2')}</span>”
                  {this.$t('down_search_export_content_success_3')}
                  “<span style="color: #077BFC;cursor:pointer;text-decoration: underline;" onClick={this.openDownCenter}>{this.$t('down_center')}</span>”
                  {this.$t('common_download')}
                </div>
              </div>
            )
            this.$notification.open({
              key,
              icon: () => (
              <div style="display: flex;align-items: center;">
                <icon-font type="gb-icon-check1" style="font-size:20px;"></icon-font>
                <span style="margin-left: 17px;font-size: 14px;font-weight: bold;color: rgba(0,0,0,0.85);line-height: 24px;">{ this.$t('down_search_export_success') }</span>
              </div>),
              description: content,
              duration: 3,
              btn: () => (<a-button style=" min-width: 72px;height: 30px;background: #FFFFFF;border-radius: 2px;border: 1px solid #077BFC;color: #077BFC;font-size: 12px;cursor: pointer;" onClick={() => this.handleMode(msgInfo)}>{this.$t('down_search_export_content_success_2')}</a-button>)
            })
          }, 1500)
          return
        }

        this.microAppStateActions.setGlobalState({
          msg: data,
          messageFlag: false
        })
      } catch (e) {
        console.log(e)
      }
    },
    openDownCenter () {
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${serviceId}/${systemCode}/sso-web#/user/download-center`
      })
    }
  },
  async mounted () {
    // let i = 10
    // let order = 80
    // let inventory = 40
    // let listing = 0
    // setInterval(() => {
    //   this.messagePush(JSON.stringify([{ 'createBy': -1, 'createTime': 1642413871863, 'msgInfo': `{"guideScheduleStr":"1011","guideStatus":1,"inventory":${inventory + i},"listing":${listing + i},"order":${order + i},"platformUserName":"amazon_sp_szm_11_CA","status":1,"userAccount":"amazon_sp_szm_11_CA"}`, 'msgTitle': '%s已将您的账号删除，请重新登录', 'msgTitleEn': '%s已将您的账号删除，请重新登录', 'msgType': 7, 'platformCode': 'SSO_SYS_USER', 'sendStatus': 2, 'sendTime': 1642413871866, 'subjectId': 233068, 'userId': 235745 }]))
    //   i += 10
    // }, 1000)
    if (!this.$ls.get(ACCESS_TOKEN)) return
    const params = {
      paging: false,
      systemName: 'SSO_SOCKET_TYPE'
    }
    const { dataList } = await QuerySystemParamsPage(params)
    if (dataList?.[0]?.systemValue === 'websock') {
      this.origin = process.env.VUE_APP_WS_URL
    }
    this.initWS()
  },
  beforeDestroy () {
    this.socket && this.socket.close()
  }
}

export default config
